import isBoolean from 'foundation/js/inputValidators/isBoolean'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'

export default [
    {
        name: 'teamName',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'isFighter',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        dependentField: 'isFighter',
        dependentFieldValue: false,
        dependentFieldValidator: (value) => value === false,
        name: 'shirtSize',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'isFighterFreeLunch',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        name: 'isChild',
        value: false,
        isValid: false,
        validator: isBoolean
    }
]
